var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-card",
    [
      _c("template", { slot: "header" }, [
        _c("span", [_vm._v("Business Verification")]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _vm.area === "HK"
            ? _c("HKbusinessKYC", {
                ref: "HKbusinessKYC",
                attrs: { area: _vm.area },
              })
            : _c("OtherBusinessKYC", {
                ref: "OtherBusinessKYC",
                attrs: { area: _vm.area },
              }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }